module.exports = __webpack_public_path__ + "img/info-chat.0407694.svg";